import {styled} from "@mui/material";

export const Wrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'disableTransition',
})(
  ({ disableTransition }) => ({
    overflow: 'hidden',
    transition: disableTransition ? 'none' : 'height 0.5s ease',
  }),
  ({ isCollapsed, height }) => ({
    height: isCollapsed ? 0 : height,
  })
);
